<!-- ── Info banner ──────────────────────────────────────────────────────── -->
<p class="locations-tab__info-banner">
  {{ "knowledge_base.info_banner.shipping_exclusions" | translate }}
</p>

<!-- ── Toolbar: add (right) ─────────────────────────────────────────────── -->
<div class="locations-tab__toolbar">
  <div class="locations-tab__toolbar-actions">
    <ui-button
      *appHasPermission="{ module: 'company', action: 'edit' }"
      type="primary-text-outlined"
      icon="plus-cc"
      iconSize="large"
      [label]="'knowledge_base.shipping_exclusions.add_exclusion' | translate"
      (click)="openAddModal()"
    >
    </ui-button>
  </div>
</div>

<!-- ── Table ─────────────────────────────────────────────────────────────── -->
<div class="locations-tab__table" [class.locations-tab__table--with-bulk-bar]="selection.hasSelection">
  <!-- Header -->
  <div class="locations-tab__table-header">
    <div class="locations-tab__table-cell locations-tab__table-cell--checkbox" (click)="$event.stopPropagation()">
      <ui-checkbox
        [checked]="selection.isAllSelected"
        [indeterminate]="selection.isPartialSelected"
        [ariaLabel]="'common.select_all' | translate"
        (changed)="selection.toggleAll($event.checked)"
      ></ui-checkbox>
    </div>
    <div class="locations-tab__table-cell">
      <span>{{ "knowledge_base.shipping_exclusions.col.location_name" | translate }}</span>
      <ui-icon
        class="locations-tab__col-hint"
        name="Info"
        size="small"
        [matTooltip]="'knowledge_base.shipping_exclusions.col.location_name_tooltip' | translate"
      ></ui-icon>
    </div>
    <div class="locations-tab__table-cell">{{ "knowledge_base.shipping_exclusions.col.address" | translate }}</div>
    <div class="locations-tab__table-cell">{{ "knowledge_base.shipping_exclusions.col.company_name" | translate }}</div>
    <div class="locations-tab__table-cell">{{ "knowledge_base.shipping_exclusions.col.erp_id" | translate }}</div>
    <div class="locations-tab__table-cell locations-tab__table-cell--actions"></div>
  </div>

  <!-- Scrollable body -->
  <div class="locations-tab__table-body">
    <!-- Loading state -->
    <div class="locations-tab__loading" *ngIf="loading$ | async">
      <div class="locations-tab__loading-spinner"></div>
    </div>

    <!-- Rows -->
    <ng-container *ngIf="!(loading$ | async) && sortedExclusions.length > 0">
      <div class="locations-tab__table-row" *ngFor="let item of sortedExclusions">
        <div class="locations-tab__table-cell locations-tab__table-cell--checkbox" (click)="$event.stopPropagation()">
          <ui-checkbox
            [checked]="selection.isSelected(item.location_id)"
            [ariaLabel]="'common.select' | translate"
            (changed)="selection.toggleOne(item.location_id, $event.checked, $event)"
          ></ui-checkbox>
        </div>
        <div class="locations-tab__table-cell"><span class="locations-tab__cell-text">{{ item.location_name || "--" }}</span></div>
        <div class="locations-tab__table-cell" [matTooltip]="item.location_address || ''"><span class="locations-tab__cell-text">{{ item.location_address || "--" }}</span></div>
        <div class="locations-tab__table-cell" [matTooltip]="item.location_company_name || ''"><span class="locations-tab__cell-text">{{ item.location_company_name || "--" }}</span></div>
        <div class="locations-tab__table-cell"><span class="locations-tab__cell-text">{{ item.location_erp_id || "--" }}</span></div>
        <div class="locations-tab__table-cell locations-tab__table-cell--actions">
          <button
            *appHasPermission="{ module: 'company', action: 'edit' }"
            class="locations-tab__remove-button"
            [matTooltip]="'common.remove' | translate"
            (click)="remove(item)"
          >
            <ui-icon name="Trash2" size="medium"></ui-icon>
          </button>
        </div>
      </div>
    </ng-container>

    <!-- Empty state -->
    <div class="locations-tab__empty" *ngIf="!(loading$ | async) && sortedExclusions.length === 0">
      <img class="locations-tab__empty-illustration" src="assets/icones/no-result-search.svg" alt="" />
      <h3>{{ "knowledge_base.shipping_exclusions.empty_state" | translate }}</h3>
    </div>
  </div>

  <!-- ───────────────────────────────────────────────────────────────────── -->
  <!-- Bulk actions for the current selection. Floats centred at the bottom of -->
  <!-- the table so selecting rows never reflows the toolbar above it.         -->
  <!-- ───────────────────────────────────────────────────────────────────── -->
  <ui-bulk-actions-bar *ngIf="selection.hasSelection" [count]="selection.count" (cleared)="selection.clear()">
    <button
      *appHasPermission="{ module: 'company', action: 'edit' }"
      class="ui-bulk-action ui-bulk-action--danger"
      (click)="bulkDelete()"
    >
      <ui-icon name="Trash2" size="medium"></ui-icon>
      <span>{{ "common.delete" | translate }}</span>
    </button>
  </ui-bulk-actions-bar>
</div>
